<template>
	<div class="homepage-container">

		<section class="top-section" :id="sections.promoted.id">
			<PromotedProjects v-if="promotedProjects?.length" :projects="promotedProjects" :isOnTop="isStuck"/>
		</section>

		<div class="home-page-wrapper">
			<div :class="['story-line-container', 'story-line', { 'stuck': isStuck }, {'is-active' : active}]" id="story-line-container" ref="stickyHeader">
				<ShareStoryLine />
			</div>

			<TopContributors :topContributors="topContributors" :topProjects="topProjects" :id="sections.contributors.id"/>

			<MapAndSubscriptions
				:id="sections.activity.id"
				v-if="mostActiveMarkets90?.length > 0 || mediumActiveMarkets90?.length > 0"
				:mostActiveMarkets90="mostActiveMarkets90"
				:mediumActiveMarkets90="mediumActiveMarkets90"
				:mostActiveMarkets30="mostActiveMarkets30"
				:mediumActiveMarkets30="mediumActiveMarkets30"
				:isSubscribed30="isSubscribed30"
				:isSubscribed90="isSubscribed90"
				:isProcessing="isProcessing"
				:subscribers="subscribers"
				@subscribeClicked="subscribeClicked"
			/>

			<HeroImage :id="sections.hero.id" />
		</div>

		<Footer/>

		<HelperButton :hasAssistance="false" />

	</div>

</template>

<script>

import PromotedProjects from "@/drc/pages/home/components/PromotedProjects.vue";
import {
	getLatestProjectsData, getProjectsCriteriaApi,
	getPromotedProjects, getSubscriptionsForUser,
	getTopContributors
} from "@/drc/services/drc-graphql-service";
import ShareStoryLine from "@/drc/components/ShareStoryLine.vue";
import TopContributors from "@/drc/pages/home/components/TopContributors.vue";
import MapAndSubscriptions from "@/drc/pages/home/components/MapAndSubscriptions.vue";
import HeroImage from "@/drc/pages/home/components/HeroImage.vue";
import Footer from "@/drc/components/Footer.vue";
import {deleteSubscription, getSubscribers, setSubscription} from "@/drc/services/drc-request-service";
import {NOTIFICATION_TYPE} from "@/common/utils/constants";
import pageSectionsMixin from "@/drc/mixins/page-section-mixin";
import * as STATISTIC_SERVICE from "@/common/services/statistic-service";
import HelperButton from "@/common/components/HelperButton";

export default {
	name: "Homepage",
	mixins: [pageSectionsMixin],
	components: {
		HelperButton,
		Footer,
		HeroImage,
		MapAndSubscriptions,
		TopContributors,
		ShareStoryLine,
		PromotedProjects
	},
	data() {
		return {
			promotedProjects: [],
			topContributors: [],
			topProjects: [],
			mostActiveMarkets30: [],
			mediumActiveMarkets30: [],
			mostActiveMarkets90: [],
			mediumActiveMarkets90: [],
			isSubscribed30: false,
			isSubscribed90: false,
			isProcessing: false,
			subscriptions: [],
			subscribers: [],
			scrollCooldown: false,
			isStuck: false,
			scrollTop: 0,
			active: false,
			isRequestFinished: true,
			sections: {
				promoted: { id: 'hero-section'},
				contributors: { id: 'contributors-section'},
				activity: { id: 'dashboard-section'},
				hero: { id: 'testimonial-section'},
			},
			sectionsLoaded: {
				'hero': false,
				'contributors': false,
				'dashboard': false,
				'testimonials': true
			}
		}
	},
	beforeMount() {
		this.startOnMounted = false;
	},
	methods: {
		subscribeClicked(period, isSubscribed) {
			this.$loader.show({text: '', description: '', buttonText: null, isBlue: false, onCancel: () => {}});
			if (this.isProcessing) {
				return
			}
			if (!this.isRequestFinished) {
				return
			}
			if (isSubscribed) {
				let subscriptionId = this.subscriptions
					.find(subscription => subscription.periodType === (period === 'last30days' ? 'MONTHLY' : 'QUARTERLY')
						&& subscription.subscriptionType === 'IS_LOCKED')
					.id;

				deleteSubscription(subscriptionId)
					.then(() => {
						this.subscriptions = this.subscriptions.filter(subscription => subscription.id !== subscriptionId);
						if (period === 'last30days'){
							this.isSubscribed30 = false;
							this.submitStatistics("30_days", "unsubscribe" )
						} else {
							this.isSubscribed90 = false;
							this.submitStatistics("90_days", "unsubscribe" )
						}
						this.showNotification(`${this.$t('subscriptions.successUnsubscribed')}`, NOTIFICATION_TYPE.SUCCESS);
					})
					.catch((error) => {
						console.error(error);
						this.showNotification(`${this.$t('notifications.error')}`, NOTIFICATION_TYPE.ERROR);
					})
					.finally(() => this.$loader.hide());
			} else {
				this.isProcessing = true;
				setSubscription({
					periodType: period === 'last30days' ? 'MONTHLY' : 'QUARTERLY',
					subscriptionType: 'IS_LOCKED',
					title: 'Global Activity Dashboard',
				})
					.then((res) => {
						this.subscriptions.push({
							id: res.data.id,
							subscriptionType: res.data.subscriptionType,
							periodType: res.data.periodType,
						});
						if (period === 'last30days') {
							this.isSubscribed30 = true;
							this.submitStatistics("30_days", "subscribe" )
						} else {
							this.isSubscribed90 = true;
							this.submitStatistics("90_days", "subscribe" )
						}
						this.showNotification(`${this.$t('subscriptions.successSubscribed')}`, NOTIFICATION_TYPE.SUCCESS);
						this.isProcessing = false;
					})
					.catch((error) => {
						console.error(error);
						this.showNotification(`${this.$t('notifications.error')}`, NOTIFICATION_TYPE.ERROR);
					})
					.finally(() => this.$loader.hide());
			}
		},
		submitStatistics(period, action){
			//period="30_days" || "90_days"; action = "subscribe" || 'unsubscribe'
			const now = new Date();
			this.$gtag.event(action.toUpperCase() + period.toUpperCase() + 'HOME_PAGE', {
				event_type: "action",
				event_category: "drc",
				event_page: "home",
				event_label: action + "to subscription " + period,
				event_location: this.$route.name,
				event_path: this.$route.path,
				user_id: this.$store.getters.getUser.id,
				user_name: this.$store.getters.getUser.fullName,
				user_email: this.$store.getters.getUser.email,
				year: now.getFullYear(),
				month: now.getMonth() + 1,
				day: now.getDate(),
				time: new Date().toJSON().split('T')[1].split('.')[0],
			});
			const props = {
				action: action.toUpperCase() + "_" + period.toUpperCase() + '_HOME_PAGE',
				comment: JSON.stringify({current_route: `${this.$route.path}`, type: "PROJECT_SUBSCRIBE", period: period, action: action}),
			}
			STATISTIC_SERVICE.addDrcStatistic(props);
		},
		generatePeriod(daysAgo) {
			const day = 1000 * 60 * 60 * 24;
			const todayDate = new Date();
			const oldDate = new Date(todayDate - (day * daysAgo));
			const oldMonth = oldDate.getMonth() + 1 < 10 ? `0${oldDate.getMonth() + 1}` : oldDate.getMonth() + 1;
			const newMonth = todayDate.getMonth() + 1 < 10 ? `0${todayDate.getMonth() + 1}` : todayDate.getMonth() + 1;
			const newDay = todayDate.getDate() < 10 ? `0${todayDate.getDate()}` : todayDate.getDate();
			const oldDay = oldDate.getDate() < 10 ? `0${oldDate.getDate()}` : oldDate.getDate();
			const period = `${oldDay}-${oldMonth}-${oldDate.getFullYear()}_${newDay}-${newMonth}-${todayDate.getFullYear()}`;
			return period;
		},
		handleScroll() {
			this.scrollTop = this.$parent.$refs.mainContent.scrollTop
		},
		loadPageData() {
			this.$loader.show({text: '', description: '', buttonText: null, isBlue: true, onCancel: () => {}});
			Promise.all([
				getPromotedProjects({showOnlyPromotedProjects: true, pageable: {page:0, size:3}, sort: {by: "promotions_displayOrder", order: "ASC"}})
					.then(response => {
						this.promotedProjects = response;
						if (!this.promotedProjects) {
							this.promotedProjects = [];
						}
						if (this.promotedProjects.length <= 2) {
							const missingCountOfProjects = 3 - this.promotedProjects.length;
							let excludingIds = this.promotedProjects.map(project => Number(project.id));

							getProjectsCriteriaApi({
								excludingProjectIds: excludingIds,
								pageable: {page:0, size: missingCountOfProjects},
								sort: {by: "management_firstDatePublish", order: "DESC"}
							})
								.then((response) => {
									this.promotedProjects.push(...response)
									this.sectionsLoaded.hero = true
								})
								.catch((error) => console.error(error))
						}
					})
					.catch((error) => console.error(error)),
				this.fetchTopContributors(),
				getLatestProjectsData({publicationDates: this.generatePeriod(90)})
					.then(response => {
						let topLocations90 = {};
						let topLocations30 = {};

						response.forEach((project) => {
							let lessThan30FromStart = (new Date() - new Date(project.management.datePublish)) < (30 * 24 * 60 * 60 * 1000);
							project.deliveryLocations.forEach((location) => {

								if (topLocations90[location.id]) {
									topLocations90[location.id].count += 1;
								} else {
									topLocations90[location.id] = {
										id: location.id,
										count: 1,
										name: location.name,
									}
								}
								if (lessThan30FromStart) {
									if (topLocations30[location.id]) {
										topLocations30[location.id].count += 1;
									} else {
										topLocations30[location.id] = {
											id: location.id,
											count: 1,
											name: location.name,
										}
									}
								}
							});
						});
						let sortedLocations90 = Object.values(topLocations90).sort((a, b) => b.count - a.count);
						this.mostActiveMarkets90 = sortedLocations90.slice(0, 3);
						this.mediumActiveMarkets90 = sortedLocations90.slice(3, sortedLocations90.length);
						let sortedLocations30 = Object.values(topLocations30).sort((a, b) => b.count - a.count);
						this.mostActiveMarkets30 = sortedLocations30.slice(0, 3);
						this.mediumActiveMarkets30 = sortedLocations30.slice(3, sortedLocations30.length);
					})
					.catch((error) => console.error(error))
					.finally(() => {
						this.sectionsLoaded.dashboard = true
					}),
				getSubscriptionsForUser(this.$store.getters.getUser.id)
					.then(response => {
						this.subscriptions = response;
						this.isSubscribed30 = response.some(subscription => subscription.periodType === "MONTHLY" && subscription.subscriptionType === 'IS_LOCKED');
						this.isSubscribed90 = response.some(subscription => subscription.periodType === "QUARTERLY" && subscription.subscriptionType === 'IS_LOCKED');
					})
					.catch((error) => console.error(error)),
				getSubscribers({subscriptionTypes: ['IS_LOCKED'], sort: {by: 'id', order: 'DESC'}})
					.then((response) => this.subscribers = [...response])
					.catch((error) => console.error(error))
			])
				.catch(() => this.showNotification(`${this.$t('notifications.error')}`, NOTIFICATION_TYPE.ERROR))
				.finally(() => this.$loader.hide())
		},
		fetchTopContributors() {
			let contributorsLast30Days = [];
			let contributorsLast90Days = [];

			return Promise.all([
				getTopContributors({months: 1, contributorsCount: 3})
					.then(response => contributorsLast30Days = response)
					.catch((error) => console.error(error)),
				getTopContributors({months: 3, contributorsCount: 3})
					.then((response) => contributorsLast90Days = response)
					.catch((error) => console.error(error)),
			])
				.then(() => {
					if (contributorsLast30Days.length >= 3) {
						console.warn(`[Contributors]: Used contributors for last 30 days`)
						this.setContributorsData(contributorsLast30Days);
						this.sectionsLoaded.contributors = true
						return contributorsLast30Days
					} else {
						console.warn(`[Contributors]: Used contributors for last 90 days`)
						this.setContributorsData(contributorsLast90Days);
						this.sectionsLoaded.contributors = true
						return contributorsLast90Days
					}
				})
		},
		setContributorsData(response) {
			this.topContributors = [];
			this.topProjects = [];
			response.forEach((contributor) => {
				this.topContributors.push(contributor);
				this.topProjects.push(contributor.projects);
			});
		},
	},
	beforeDestroy() {
		this.$parent.$refs.mainContent.removeEventListener('scroll', this.handleScroll);
	},
	watch: {
		scrollTop() {
			const stickyEl = this.$refs.stickyHeader;
			if (!stickyEl) return;

			const rect = stickyEl.getBoundingClientRect();
			this.isStuck = rect.top <= 65;

			this.active =  rect.top <= 0
		},
		'sectionsLoaded.hero'(newVal, oldVal) {
			if (newVal) {
				if (this.sectionsLoaded.dashboard && this.sectionsLoaded.contributors && this.sectionsLoaded.testimonials) {
					let observer = this.observeSectionVisibility();
					this.attachObserverToAllSections(observer);
					this.autoScrollToSectionOnPageLoad();
				}
			}
		},
		'sectionsLoaded.dashboard'(newVal, oldVal) {
			if (newVal) {
				if (this.sectionsLoaded.hero && this.sectionsLoaded.contributors && this.sectionsLoaded.testimonials) {
					let observer = this.observeSectionVisibility();
					this.attachObserverToAllSections(observer);
					this.autoScrollToSectionOnPageLoad();
				}
			}
		},
		'sectionsLoaded.contributors'(newVal, oldVal) {
			if (newVal) {
				if (this.sectionsLoaded.hero && this.sectionsLoaded.dashboard && this.sectionsLoaded.testimonials) {
					let observer = this.observeSectionVisibility();
					this.attachObserverToAllSections(observer);
					this.autoScrollToSectionOnPageLoad();
				}
			}
		}
	},
	mounted() {
		this.$parent.$refs.mainContent.addEventListener('scroll', this.handleScroll, { passive: true });
		this.handleScroll();
		this.loadPageData();
	},
}

</script>

<style lang="scss">
@import "@/common/assets/css/_variables.scss";

.homepage-container {
	height: fit-content;

	.top-section {
		position: relative;
	}

	.home-page-wrapper {
		background: #F2F2F7;
		display: flex;
		flex-direction: column;

		.story-line {
			overflow: hidden;
			position: sticky;
			width: 100%;
			top: 0;
			z-index: 2;
			margin-top: 0;
			background: transparent;
			pointer-events: none;
			min-height: 20vh;
			height: fit-content;

			.share-story-container {
				min-height: 20vh;
				pointer-events: auto;

				@media (min-width: 2200px) {
					max-height: 20vh;
				}

				@media (max-width: 1300px) {
					padding: 16px 32px;
				}

				@media (max-width: 780px) {
					padding: 16px 15px;
				}

				.share-story-content {
					flex-direction: row;
					flex-wrap: nowrap;
					gap: 10px;
					align-items: center;
					justify-content: space-between;
					max-width: 1440px;

					p {
						font-family: Tiempos Text,serif;
						font-weight: 600;
						font-size: 3vh;
						line-height: 140%;
						letter-spacing: 0.36px;
						vertical-align: middle;
						margin-top: 0;
						margin-bottom: 0;
						width: 80%;
					}

					.button-wrapper > button {
						padding: 5% 16px;
						right: -3vh;

						&:hover {
							right: 0;
						}

						span {
							font-size: 2vh;
							line-height: 100%;
						}

						img {
							width: 2.5vh;
							height: 2.5vh;
							margin-left: 1vh;
						}
					}

					@media (min-width: 2200px) {
						p {
							font-size: 1.7vh;
							line-height: 100%;

							br {
								display: none;
							}
						}

						.button-wrapper > button {
							padding: 4% 14px;
							right: -3.5vh;

							span {
								font-size: 1.4vh;
								line-height: 100%;
							}

							img {
								width: 2vh;
								height: 2vh;
								margin-left: 1vh;
							}
						}
					}

					@media (max-width: 1300px) {
						gap: 10px;

						p {
							font-size: 2.7vh;
							line-height: 110%;

							br {
								display: none;
							}
						}

						.button-wrapper > button {
							padding: 4% 14px;

							span {
								font-size: 1.8vh;
								line-height: 100%;
							}

							img {
								width: 2.0vh;
								height: 2.0vh;
							}
						}
					}

					@media (max-width: 780px) {
						flex-direction: column;
						gap: 15px;

						p {
							font-size: 2.3vh;
							line-height: 100%;
							text-align: center;

							br {
								display: none;
							}
						}

						.button-wrapper > button {
							padding: 8% 16px;

							span {
								font-size: 1.6vh;
								line-height: 100%;
							}
						}
					}

					@media (max-width: $mobile) {
						.button-wrapper > button {
							right: 0;
						}
					}
				}
			}

			&.stuck {
				pointer-events: none;

				.share-story-container {
					min-height: 10vh;
					pointer-events: auto;

					.share-story-content {
						p {
							font-family: Tiempos Text, serif;
							font-weight: 500;
							letter-spacing: 0.36px;
							font-size: 2.2vh;
							line-height: 100%;
							flex-direction: row;
							text-align: left;
						}

						@media (max-width: 780px) {
							p {
								text-align: center;
							}
						}
					}
				}

			}

		}
	}

}
</style>
